module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-datos"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "little"
  }, [_vm._v("Mis datos de seguridad y notificación")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), (_vm.isLoading) ? _c('loading') : [_c('section', {
    staticClass: "body flex",
    class: {
      'flex-direction-column': _vm.isMobile
    }
  }, [_c('div', {
    staticClass: "flex flex-direction-column flex-1"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Ingresa tu nueva contraseña")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control"
  }, [_c('p', [_vm._v("Ingresa nuevamente la contraseña")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatNewPassword),
      expression: "repeatNewPassword"
    }],
    staticClass: "input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.repeatNewPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repeatNewPassword = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Email de notificaciones")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "control flex-1"
  }, [_c('p', [_vm._v("Ingrese su contraseña actual")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.guardar($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _c('section', {
    staticClass: "contenedor-guardar"
  }, [_c('button', {
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.isSaving
    },
    on: {
      "click": _vm.guardar
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-save fa-fw fa-lg"
  })]), _c('span', [_vm._v("Guardar")])])])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78f8b02c","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Datos_Personales_Seguridad.vue
// module id = 915
// module chunks = 0